module.exports = __webpack_public_path__ + "img/globe.cf069d38.svg";